import { useEffect } from "react";
import { customToast } from "../../utils/General";
import { useNavigate } from "react-router-dom";

const PaymentResult = () => {
  let navigate = useNavigate();

  const Token = localStorage.getItem("Token");
  const url = window.location.href;

  useEffect(() => {
    Token ? navigate("/credit") : navigate("/login");
    return () => {
      if (url?.includes("false")) {
        customToast("error", "عملیات افزایش اعتبار حساب کاربری با خطا مواجه شد.");
      } else {
        customToast("success", "پرداخت شما با موفقیت انجام شد");
      }
    };
    
  }, []);
  return <></>;
};

export default PaymentResult;
